export const toolList = [{
    id: "sockit",
    title: "Sockit",
    image: "/images/sockit.svg",
    url: "/sockit",
    description: "Sockit is a self-contained toolkit for assigning probabilistic Standard Occupational Classification (SOC) codes to free-text job titles.",
    type: "tool"
}]